import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useEmergencyStore = create(
  persist(
    (set) => ({
      contact: {
        name: '',
        phone: '',
        message: '긴급 상황입니다. 도움이 필요합니다. 제 현재 위치는 다음과 같습니다.',
      },
      setContact: (newContact) => set({ contact: newContact }),
      clearContact: () => set({
        contact: {
          name: '',
          phone: '',
          message: '긴급 상황입니다. 도움이 필요합니다. 제 현재 위치는 다음과 같습니다.',
        }
      }),
    }),
    {
      name: 'emergency-contact-storage',
    }
  )
);
